import { useNetworkState } from "../hooks/appStateHook";
import useClientConfig from "../hooks/clientConfigHook";
import { signOut } from "../reducers/initContext";
import { useApp } from "./AppProvider";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";

const Logout = () => {
    const { isOnline } = useNetworkState();
    const clientConfig = useClientConfig();
    const dispatch = useDispatch();
    const App = useApp();
    
    if (isOnline || !clientConfig.enableOfflineMode) {
        signOut(App, dispatch);
        return <Navigate to="/signin" replace></Navigate>
    }
    return <Navigate to='/' replace></Navigate>
}

export default Logout
